<div class="flex flex-col self-stretch gap-2.5">
  <h1 class="content-unit-headline">New Content Unit</h1>
  <p class="content-unit-subtext">Welcome to your central Content Unit dashboard, the ultimate hub for designing and refining modular certificate elements.
                                  Here, you can effortlessly navigate your entire library to access and update existing units at a moment's notice. If you're
                                  looking
                                  to start fresh, simply select the "New Content Unit" button to launch a blank workspace. Once active, the editor gives you
                                  total
                                  creative freedom to integrate and customize placeholders exactly to your liking. This intuitive system ensures you maintain
                                  complete control over both your archived assets and your brand-new creations.</p>
  <span class="w-fit"
        [pTooltip]="permissionService.hasRedactRights() ? 'Create a new content unit' : 'Insufficient permissions'"
  >
    <button pButton
            type="button"
            data-test="content-unit-new-button"
            severity="primary"
            [disabled]="!permissionService.hasRedactRights()"
            (click)="router.navigate(['/content-unit/create'])"
    >
      New Content Unit
    </button>
  </span>
</div>
